type Props = {
  profileImage: any;
  defaultImage: JSX.Element;
  alt: string;
};

function ProfileImage({ profileImage, defaultImage, alt }: Props) {
  return (
    <span className="flex h-28 w-28 items-center justify-center overflow-hidden rounded-ll border border-white bg-primary">
      {profileImage ? <img className="h-full w-full object-cover" src={profileImage} alt={alt} /> : defaultImage}
    </span>
  );
}
export default ProfileImage;
